import { PureComponent } from "react";

import { TriggerButton } from "widgets";

import { type IDatasetViewerState, type SelectedDataSeries } from "../../redux/modules/dataset-viewer.js";
import AnalyticalDataExportDialog from "../analytical-viewer/AnalyticalDataExportDialog.js";
import { PopOverActionWidget } from "./overlays/index.js";

export interface IAnalyticalDataExportButtonProps {
  dataViewer: IDatasetViewerState;
}

class AnalyticalDataExportButton extends PureComponent<IAnalyticalDataExportButtonProps> {
  getDisabledTooltipText() {
    if (
      this.props.dataViewer.selectedDataSeries.length === 0 ||
      this.props.dataViewer.selectedAnnotations.length === 0
    ) {
      return "Nothing to be exported";
    }
    if (this.props.dataViewer.selectedDataSeries.some((dataseries: SelectedDataSeries) => dataseries.isLoading)) {
      return "Data Series are currently loading";
    }
  }

  render() {
    const buttonDisabledTooltip = this.getDisabledTooltipText();

    return (
      <PopOverActionWidget
        title={"Export"}
        actionWidget={({ open, isOpen }) => (
          <TriggerButton
            icon={"cloud_download"}
            onPress={() => open()}
            isDisabled={buttonDisabledTooltip}
            label={"Export"}
            showLabel
          />
        )}
      >
        {({ close }) => <AnalyticalDataExportDialog onClose={() => close && close()} />}
      </PopOverActionWidget>
    );
  }
}

export default AnalyticalDataExportButton;
